export enum Product {
  Eks = 'eks',
  Rlv = 'rlv',
  Dkr = 'dkr',
}
